import {
  UICampaignData,
  UICampaignRecipient,
  ActivityEvent,
} from '../../../utils/campaignAdapter';

// Re-export UI types for use in components
export type CampaignData = UICampaignData;
export type CampaignRecipient = UICampaignRecipient;
export type { ActivityEvent };

export type FilterStatus = 'all' | 'draft' | 'queued' | 'replied' | 'clicked' | 'opened' | 'sent' | 'bounced';
export type SortField = 'name' | 'status' | 'engagement' | 'activity';
export type SortDirection = 'asc' | 'desc';

export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  isTyping?: boolean;
}

export interface StatItem {
  label: string;
  value: number;
  rate?: number;
  filter: FilterStatus;
}

export const STATUS_ORDER: Record<string, number> = {
  replied: 1,
  clicked: 2,
  opened: 3,
  delivered: 4,
  sent: 5,
  queued: 6,
  bounced: 7,
  draft: 8,
};

export const STATUS_COLORS: Record<string, { bg: string; text: string; dot: string }> = {
  replied: { bg: 'bg-purple-50', text: 'text-purple-600', dot: 'bg-purple-500' },
  clicked: { bg: 'bg-blue-50', text: 'text-blue-600', dot: 'bg-blue-500' },
  opened: { bg: 'bg-green-50', text: 'text-green-600', dot: 'bg-green-500' },
  delivered: { bg: 'bg-gray-50', text: 'text-gray-600', dot: 'bg-gray-400' },
  sent: { bg: 'bg-gray-50', text: 'text-gray-500', dot: 'bg-gray-400' },
  queued: { bg: 'bg-yellow-50', text: 'text-yellow-600', dot: 'bg-yellow-500' },
  bounced: { bg: 'bg-red-50', text: 'text-red-600', dot: 'bg-red-500' },
  draft: { bg: 'bg-neutral-50', text: 'text-neutral-500', dot: 'bg-neutral-400' },
};

export const STATUS_ICONS = {
  sent: 'Mail',
  delivered: 'CheckCircle',
  opened: 'MailOpen',
  clicked: 'MousePointerClick',
  replied: 'Reply',
  bounced: 'AlertCircle',
  queued: 'Clock',
  draft: 'FileText',
} as const;

export const EMAIL_VARIABLES = [
  { key: 'first_name', label: 'First Name', description: "Recipient's first name" },
  { key: 'last_name', label: 'Last Name', description: "Recipient's last name" },
  { key: 'full_name', label: 'Full Name', description: "Recipient's full name" },
  { key: 'company_name', label: 'Company', description: "Recipient's company" },
  { key: 'job_title', label: 'Job Title', description: "Recipient's job title" },
  { key: 'sender_name', label: 'Your Name', description: 'Your name (sender)' },
];

export interface PendingChanges {
  type: 'email' | 'settings';
  subject?: string;
  body?: string;
  sendWindow?: { start: string; end: string; days: string[] };
}

export interface EngagementInsight {
  score: number;
  pattern: string;
  opens: number;
  clicks: number;
}
